import { useQuery } from '@tanstack/react-query';
import type { TranscriptState } from '@avslack/shared';
import { getTranscriptStates } from '../lib/api';

/**
 * Melyik lezart olelesrol van atirat - es milyen allapotban.
 *
 * A csatorna folyamaban ebbol dol el, hol jelenjen meg az "Atirat" gomb.
 * **Egy kerdes fedi az egesz kepernyot**: hivasonkent kerdezve egy nap
 * elozmenye tucatnyi kerest inditana.
 *
 * Amihez a nezonek nincs joga, az ki sem kerul a valaszba - a gomb sem jelenik
 * meg, tehat a felulet nem kinal olyat, amit ugysem nyithat meg.
 */
export function useTranscriptStates(huddleIds: string[]) {
  // A sorrend nem szamit, a halmaz igen: igy egy ujrarendezes nem inditja ujra.
  const key = [...new Set(huddleIds)].sort();

  return useQuery({
    queryKey: ['transcript-states', key.join(',')],
    queryFn: () => getTranscriptStates(key),
    enabled: key.length > 0,
    /*
      Amig keszul valamelyik, gyakrabban nezunk ra.

      A feldolgozas a hivas utan meg par masodpercig tart; enelkul a gomb
      "keszul" allapotban ragadna, amig a felhasznalo ujra be nem tolti.
    */
    refetchInterval: (query) =>
      Object.values(query.state.data ?? {}).some(
        (state: TranscriptState) => state === 'processing' || state === 'recording',
      )
        ? 5000
        : false,
    staleTime: 30_000,
  });
}
